/**
 * Node modules
 */
import styled from 'styled-components';

/**
 * Styled components
 */
export default styled.tbody``;
